export class SceneNotReadyError extends Error {
	readonly cause?: string;
	constructor (message: string, cause?: string) {
		super(message);
		this.name = 'SceneNotReadyError';
		this.cause = cause;
	}
}

export class ExportSceneUnavailableError extends Error {
	constructor (message: string) {
		super(message);
		this.name = 'ExportSceneUnavailableError';
	}
}

export class ModelLoadError extends Error {
	readonly failedPaths: Array<string>;
	constructor (message: string, failedPaths: Array<string>) {
		super(message);
		this.name = 'ModelLoadError';
		this.failedPaths = failedPaths;
	}
}

export class ExportValidationError extends Error {
	readonly missing: Array<string>;
	constructor (message: string, missing: Array<string>) {
		super(message);
		this.name = 'ExportValidationError';
		this.missing = missing;
	}
}
